<template>
  <div>
    <header>
      <span class="h6"
        >Enter your email below to be sent instructions for resetting your
        password.</span
      >
    </header>

    <el-form @submit.native.prevent>
      <el-form-item :error="retrieveFieldError(modelState, 'Email')" :required="true">
        <el-input placeholder="Email" v-model="resetPassword.email"></el-input>
      </el-form-item>

      <button
        style="margin-top: 40px"
        class="ts-btn ts-btn-rounded ts-btn-secondary ts-btn-full"
        :class="{ loading: isLoading }"
        @click="doReset"
      >
        <i>
          <v-icon name="circle-notch" />
        </i>
        Submit
      </button>
      <div style="margin-top: 10px; text-align: center">
        <p class="secondary-p">
          Go back to <a href="/apprentice-login">login</a>
        </p>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resetPassword: {
        email: null
      },
      isLoading: false,
      modelState: {},
    };
  },
  methods: {
    doReset() {
      this.isLoading = true;

      if (!this.validateEmail()) {
        this.isLoading = false;
        return;
      }

      this.$store
        .dispatch("account/forgotPassword", this.resetPassword)
        .then(() => {
          this.$message({
            type: "success",
            message: `Change password request sent. Please check your email.`,
          });
          this.$router.push({ name: "apprentice-login" });
        })
        .catch((res) => {
          this.modelState = res;
          this.isLoading = false;
        });
    },
    validateEmail() {
      let isValid = true;
      if (this.resetPassword.email === null || this.resetPassword.email === '') {
        this.modelState = { Email: ['The Email field is required.'] };
        isValid = false;
      }
      
      let isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.resetPassword.email)
      if (this.resetPassword.email != null && this.resetPassword.email != '' && !isValidEmail) {
        this.modelState = { Email: ['The Email field is not a valid email address.'] };
        isValid  =false;
      }

      return isValid;
    },
  },
};
</script>
